import { Typography, Modal, Card, Button, Grid }from '@mui/material';
import './styles.css';
import { useNavigate } from 'react-router-dom';

const PitchTestEndModal = (props) => {
	const {
		pitchTestLevelData, 
		questionArray, 
		clueSeenArray, 
		skippedNotesArray, 
		showEndLevelModal, 
		proceedNextLevel, 
		redoSameLevel, 
		isLastLevel
	} = props;
	let navigate = useNavigate();

  return (
		<Modal
			open={showEndLevelModal}
		>
			<Card 
				className='modalCard' 
				style={{
					borderRadius: '15px', 
					minWidth: '250px', 
					backgroundImage: (clueSeenArray.length + skippedNotesArray.length === 0) ? 'url("/assets/images/celebrate.gif")' : '', 
					backgroundSize: '100%',
					backgroundColor: ' #e9f3fb' // AliceBlue + more grey
				}}>
				<Typography variant="h6" component="h2">
					End of {pitchTestLevelData.pitchTestTitle}
				</Typography>
				<Typography sx={{ mt: 2 }}>
					{pitchTestLevelData.pitchTestDescription}
				</Typography>
				<Typography sx={{ mt: 2 }}>
					<strong>Below is your score for {pitchTestLevelData.pitchTestTitle}:</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total number of notes tested: <strong>{questionArray.length}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total number of notes played correctly: <strong>{questionArray.length - skippedNotesArray.length}</strong>
						<img 
							src={skippedNotesArray.length === 0 ? "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExeDV5aTl3ZDBpMzk5bHJ3NXJpZGVqejFkZDVwZTk1anowbWkxczdyNSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/5mUGrtcKCjKXE8Vsef/giphy.gif" : ''}
							style={{maxHeight: '40px', marginLeft: '5px'}}
							alt={skippedNotesArray.length === 0 ? "Correct Celebration Gif" : ''}
					/>	
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total number of clues seen: <strong>{clueSeenArray.length}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total number of notes skipped: <strong>{skippedNotesArray.length}</strong>
				</Typography>
				{skippedNotesArray.length + (clueSeenArray.length - skippedNotesArray.length) >= 3 && !!pitchTestLevelData.pitchTestRecommendedLearning.length &&
					<>
						<Typography sx={{ mt: 2 }}>
							Because you looked up for clues {!!skippedNotesArray.length && 'and skipped some notes'}, we highly recommend you to read and understand the following patterns before going to the next level:
						</Typography>
						<Grid container direction={'column'}>
							{pitchTestLevelData.pitchTestRecommendedLearning.map(course => (
								<Button  style={{textTransform: 'none'}} href={course.url} key={course.name} color='success'>{course.name}</Button>
							))}
						</Grid>
					</>
				}
				<Grid justifyContent="space-between" direction="row" container style={{marginTop: '10px'}}>
					<Button onClick={redoSameLevel} id='modalButton' variant="contained" color="secondary">Try this Level again</Button>
					{isLastLevel ?
						<Button onClick={() => navigate('/')} id='modalButton' variant="contained" color="secondary">Home</Button>
						:
						<Button onClick={proceedNextLevel} id='modalButton' variant="contained" color="secondary">Next Level</Button>
					}
				</Grid>
			</Card>
		</Modal>
	)
}

export default PitchTestEndModal;